import { Toast } from "native-base";

const ErrorToast = (message, title = "Error") => {
	Toast.show({
		title: title,
		description: message,
		status: "error",
		placement: "top",
		backgroundColor: "#fd416a",
		duration: 15000,
		// duration: null,
	});
};

export default ErrorToast;
